import { render, staticRenderFns } from "./productSalesData.vue?vue&type=template&id=11f14bae&scoped=true&"
import script from "./productSalesData.vue?vue&type=script&lang=js&"
export * from "./productSalesData.vue?vue&type=script&lang=js&"
import style0 from "./productSalesData.vue?vue&type=style&index=0&id=11f14bae&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f14bae",
  null
  
)

export default component.exports